/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterDeviceTokenRequest
 */
export interface RegisterDeviceTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceTokenRequest
     */
    deviceToken: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceTokenRequest
     */
    platform: string;
}

/**
 * Check if a given object implements the RegisterDeviceTokenRequest interface.
 */
export function instanceOfRegisterDeviceTokenRequest(value: object): value is RegisterDeviceTokenRequest {
    if (!('deviceToken' in value) || value['deviceToken'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function RegisterDeviceTokenRequestFromJSON(json: any): RegisterDeviceTokenRequest {
    return RegisterDeviceTokenRequestFromJSONTyped(json, false);
}

export function RegisterDeviceTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterDeviceTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceToken': json['deviceToken'],
        'platform': json['platform'],
    };
}

export function RegisterDeviceTokenRequestToJSON(json: any): RegisterDeviceTokenRequest {
    return RegisterDeviceTokenRequestToJSONTyped(json, false);
}

export function RegisterDeviceTokenRequestToJSONTyped(value?: RegisterDeviceTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deviceToken': value['deviceToken'],
        'platform': value['platform'],
    };
}

